import React, { useEffect, useState } from "react";
import { CheckCircle, XCircle, AlertTriangle } from "lucide-react";
import { setShowAlertHandler, AlertType } from "./AlertService";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import './AlertModal.css'; // Import the CSS file for styling
import { DialogOverlay } from "@radix-ui/react-dialog";

const icons = {
  success: <CheckCircle className="text-green-500 w-12 h-12" />,
  error: <XCircle className="text-red-500 w-12 h-12" />,
  warning: <AlertTriangle className="text-yellow-500 w-12 h-12" />,
};

export default function AlertModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState<{ type: AlertType; message: string } | null>(
    null
  );

  useEffect(() => {
    setShowAlertHandler((alertData) => {
      setData(alertData);
      setIsOpen(true);
    });
  }, []);




  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogOverlay className="dialog-overlay" >
      <DialogContent  hideCloseButton className="max-w-md rounded-lg shadow-lg">
        <DialogHeader className="flex flex-col items-center text-center">
          {data && icons[data.type]}
          
        </DialogHeader>
        <p className="alert-message dark:text-white">{data?.message}</p>
        <div className="mt-4 flex justify-center">
          <button
            onClick={() => setIsOpen(false)}
            className="alert-button"
          >
            OK
          </button>
        </div>
      </DialogContent>
      </DialogOverlay>
    </Dialog>
  );
}
